module.exports = __webpack_public_path__ + "h5/img/wufu2@2x.3e925761.png";